module.exports = __webpack_public_path__ + "static/img/brees-2011-slide-8.e0bcb4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-slide-8.jpg
// module id = 8CYc
// module chunks = 1